<script>
</script>

<div class="progress-bar bg-muted h-1 w-full z-50 fixed top-0 left-0">
  <div class="bg-primary h-1 animate-pulse" />
</div>
